module.exports = __webpack_public_path__ + "img/arrow-right-blue.a1e1e62d.svg";